import { type AuthorizedUser, UserRolesTypes } from '@models';
import { type Action, type ActionReducer, createReducer, type MetaReducer, on } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';

import { AuthActions } from './auth.actions';

export interface UserState extends AuthorizedUser {
  isLoading?: boolean;
}

export const initialUserState: UserState = {
  email: '',
  firstName: '',
  homeClientUserSettings: {
    userSessionTimeoutMinutes: 10,
  },
  id: '',
  isLoading: false,
  lastActivity: '',
  lastName: '',
  notificationsPreferences: {
    emailEnabled: false,
    smsEnabled: false,
  },
  organizationName: '',
  phone: {
    countryCode: '',
    countryNumberCode: '',
    number: '',
    smsOptIn: false,
  },
  role: {
    id: '',
    name: UserRolesTypes.Empty,
  },
  status: '',
};

export const authReducer = createReducer(
  initialUserState,

  on(AuthActions.login, (_state, action) => {
    return action.user;
  }),

  on(AuthActions.logout, () => {
    return initialUserState;
  }),

  on(AuthActions.forgotPassword, state => {
    return { ...state, isLoading: true };
  }),

  on(AuthActions.passwordRecovery, state => {
    return { ...state, isLoading: true };
  }),

  on(AuthActions.passwordRecovered, state => {
    return { ...state, isLoading: false };
  }),

  on(AuthActions.forgotPasswordSuccess, state => {
    return { ...state, isLoading: false };
  }),

  on(AuthActions.authActionError, state => {
    return { ...state, isLoading: false };
  }),

  on(AuthActions.authChangeUserPassword, state => {
    return { ...state, isLoading: true };
  }),

  on(AuthActions.authUserPasswordChanged, state => {
    return { ...state, isLoading: false };
  }),

  on(AuthActions.updatePersonalDataSuccess, (state, action) => {
    return { ...state, ...action.user };
  }),

  on(AuthActions.refreshProfileSuccess, (state, action) => {
    return { ...state, ...action.user };
  }),

  immerOn(AuthActions.superAdminClientCreated, (state, action) => {
    let clients = state.userClients;

    if (clients) {
      clients = [...clients, action.newClient];
    }

    return { ...state, ...{ userClients: clients } };
  }),
);

export const clearStateAfterLogout: MetaReducer = (reducer: ActionReducer<any>) => {
  return function (state: object, action: Action) {
    if (action.type === AuthActions.logout.type) {
      state = {};
    }

    return reducer(state, action);
  };
};
